import { useFormikContext, Form } from 'formik'
import { Button, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'

import { ETranslationNs, IApprovalFeedbacksForm } from 'src/types'
import { HelperWrapper } from 'src/components/helper-wrapper'
import { TextInputWithHelper } from 'src/components/text-input-with-helper-icon'

import { useStyles } from '../styles'

interface IProps {
  isUpdate?: boolean
}

export const ApprovalFeedbackForm = ({ isUpdate = false }: IProps) => {
  const [t] = useTranslation([ETranslationNs.Common, ETranslationNs.Form])
  const { errors, values, handleChange, isSubmitting, dirty, handleBlur, touched } =
    useFormikContext<IApprovalFeedbacksForm>()
  const classes = useStyles()

  return (
    <Form className={`${classes.formWrapper} ${classes.formWrapperWithHeight}`}>
      <div className={classes.inputsWrapper}>
        <Typography className={classes.title}>{isUpdate ? 'Update' : 'Create'}</Typography>
        <div className={classes.inputsWrapper}>
          <TextInputWithHelper
            inputName="name"
            handleChange={handleChange}
            handleBlur={handleBlur}
            value={values.name}
            inputUpperLabel={
              <HelperWrapper
                t={'decline-reasons-name-input-label'}
                ns={ETranslationNs.Common}
                isInputLable
                isMandatory
              />
            }
            inputPlaceholder={t('decline-reasons-name-input-placeholder.v', {
              ns: ETranslationNs.Common,
            })}
            error={touched.name && errors.name ? <HelperWrapper t={errors.name} /> : null}
            fullWidth
            withoutPlaceholderPrepend
          />
          <TextInputWithHelper
            inputName="text"
            handleChange={handleChange}
            handleBlur={handleBlur}
            value={values.text}
            inputUpperLabel={
              <HelperWrapper
                t={'decline-reasons-text-input-label'}
                ns={ETranslationNs.Common}
                isInputLable
                isMandatory
              />
            }
            inputPlaceholder={t('decline-reasons-text-input-placeholder.v', {
              ns: ETranslationNs.Common,
            })}
            error={touched.text && errors.text ? <HelperWrapper t={errors.text} /> : null}
            fullWidth
            withoutPlaceholderPrepend
          />
        </div>
      </div>
      <Button
        variant="contained"
        disabled={isSubmitting || !dirty || Object.keys(errors).length > 0}
        type="submit"
      >
        <HelperWrapper t="save-button-text" />
      </Button>
    </Form>
  )
}
